var UIRouterPluginBase =
/** @class */
function () {
  function UIRouterPluginBase() {}

  UIRouterPluginBase.prototype.dispose = function (router) {};

  return UIRouterPluginBase;
}();

export { UIRouterPluginBase };